import { useTokenPrice, stringToBlobUrl, getChainById } from "common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Summary(_ref) {
  let {
    selectedPayoutToken,
    totalDonation,
    chainId,
    enoughBalance
  } = _ref;
  const {
    data: payoutTokenPrice
  } = useTokenPrice(selectedPayoutToken.redstoneTokenId, selectedPayoutToken.priceSource);
  const totalDonationInUSD = payoutTokenPrice && totalDonation * Number(payoutTokenPrice);
  const chain = getChainById(chainId);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: `flex flex-row justify-between mt-2 ${enoughBalance && "mb-5"}`,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/_jsx("p", {
          className: "mb-2",
          children: "Your contribution on"
        }), /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx("img", {
            className: "inline max-w-[32px] mr-2",
            alt: chain.prettyName,
            src: stringToBlobUrl(chain.icon)
          }), chain.prettyName]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/_jsxs("p", {
          className: "text-right",
          children: [/*#__PURE__*/_jsx("span", {
            "data-testid": "totalDonation",
            className: "mr-2",
            children: totalDonation
          }), /*#__PURE__*/_jsx("span", {
            "data-testid": "summaryPayoutToken",
            children: selectedPayoutToken.code
          })]
        }), payoutTokenPrice && /*#__PURE__*/_jsx("div", {
          className: "flex justify-end mt-2",
          children: /*#__PURE__*/_jsxs("p", {
            className: "text-[14px] text-[#979998] font-bold",
            children: ["$", totalDonationInUSD === null || totalDonationInUSD === void 0 ? void 0 : totalDonationInUSD.toFixed(2)]
          })
        })]
      })]
    }), !enoughBalance && /*#__PURE__*/_jsx("p", {
      "data-testid": "insufficientBalance",
      className: "rounded-md font-normal text-pink-500 flex justify-start items-center mt-2 mb-5 text-xs",
      children: /*#__PURE__*/_jsxs("span", {
        children: [`Insufficient funds in your wallet.`, " ", /*#__PURE__*/_jsx("br", {}), `Please bridge funds over to ${getChainById(chainId).prettyName}.`]
      })
    })]
  });
}